<div class="bloco-card">
  <div class="bloco-header">
    <h3 class="bloco-title">
      Novas oportunidades
      <mat-icon title="Últimas obras inseridas no periodo de 15 dias" class="info-icon">info</mat-icon>
    </h3>
  </div>

  <div class="bloco-body">
    <ng-container *ngIf="!loading; else skeleton">
      <div class="modulo-section" *ngFor="let grupo of grupos">
        <span class="modulo-label" [ngClass]="getModuleColorClass(grupo.moduleName)">{{ grupo.moduleName }}</span>

        <div class="cards-row">
          <div
            class="obra-card"
            *ngFor="let obra of grupo.works"
            (click)="abrirFichaObra(obra)"
          >
            <div class="obra-img">
              <img
                *ngIf="getImageUrl(obra)"
                [src]="getImageUrl(obra)"
                [alt]="obra.workName"
              />
              <i *ngIf="!getImageUrl(obra)" class="ti ti-photo" aria-hidden="true"></i>
            </div>
            <div class="obra-info">
              <p class="obra-name" [title]="obra.workName">{{ obra.workName }}</p>
              <p class="obra-company" [title]="obra.companyName">{{ obra.companyName }}</p>
              <div class="obra-meta">
                <span class="obra-fase">{{ obra.workPhase }}</span>
                <span class="obra-data">{{ obra.updatedAt }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="grupos.length === 0">
        Nenhuma oportunidade encontrada nos últimos 30 dias.
      </div>
    </ng-container>

    <ng-template #skeleton>
      <div class="skeleton-section" *ngFor="let i of [1,2]">
        <div class="skeleton-label"></div>
        <div class="skeleton-cards-row">
          <div class="skeleton-card" *ngFor="let j of [1,2,3,4,5]"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>